// รับจ่าย — ค่าใช้จ่าย menu group (S2 ค่าใช้จ่ายรายวัน, S3 อนุมัติค่าใช้จ่าย). Kept free of imports so
// the sidebar and the router can read the paths without pulling the pages' helpers in.

export const EXPENSE_PATH = "/expenses";
export const DAILY_EXPENSE_PATH = `${EXPENSE_PATH}/daily`;
export const DAILY_EXPENSE_DAY_PATH = `${DAILY_EXPENSE_PATH}/:date`;
export const DAILY_EXPENSE_REVIEW_PATH = `${EXPENSE_PATH}/approval`;
export const MONTHLY_EXPENSE_CLOSE_PATH = `${EXPENSE_PATH}/month-close`;
export const MONTH_ESTIMATE_PATH = `${EXPENSE_PATH}/estimate`;
export const ROUTE_SALES_TARGET_PATH = `${EXPENSE_PATH}/route-targets`;

export const EXPENSE_MENU_TITLE = "ค่าใช้จ่าย";
export const DAILY_EXPENSE_MENU_TITLE = "ค่าใช้จ่ายรายวัน";
export const DAILY_EXPENSE_REVIEW_MENU_TITLE = "อนุมัติค่าใช้จ่าย";
export const DAILY_EXPENSE_REVIEW_TITLE = "อนุมัติค่าใช้จ่ายรายวัน";
export const MONTHLY_EXPENSE_CLOSE_MENU_TITLE = "ปิดเดือน / ประมาณการ";
export const MONTH_ESTIMATE_MENU_TITLE = "ประมาณการเดือนนี้";
export const ROUTE_SALES_TARGET_MENU_TITLE = "เป้าหมายสายส่ง";

/** The S3 deep link (from S4's warning strip): range, one branch, status and view. */
export const REVIEW_LINK_PARAM = {
  START: "start",
  END: "end",
  BRANCH: "branch",
  STATUS: "status",
  VIEW: "view",
} as const;

/** The list's month travels in the query string, so ย้อนกลับ from a day lands on its month. */
export const MONTH_PARAM = "month";

/** The API's business day and month. */
export const API_DATE_FORMAT = "YYYY-MM-DD";
export const API_MONTH_FORMAT = "YYYY-MM";
/** Same day format as the other report pages (ค.ศ.). */
export const DISPLAY_DATE_FORMAT = "DD/MM/YYYY";

/** The API serves business days from 2000 onwards; an earlier month would only be refused. */
export const EARLIEST_EXPENSE_MONTH = "2000-01-01";

/** Head office's review range cap — the server's DAILY_EXPENSE_REVIEW_MAX_DAYS. */
export const REVIEW_MAX_DAYS = 31;

/** The server caps a reject reason here. */
export const REJECT_REASON_MAX_LENGTH = 500;

export const UNIT_TEXT = "หน่วย: บาท";
export const EMPTY_CELL_TEXT = "–";
export const AMOUNT_ERROR_TEXT = "ตัวเลข ≥ 0 ทศนิยมไม่เกิน 2 ตำแหน่ง";
export const PREFILL_TEXT = "ดึงจากแจ้งยอดโอน";
export const LOAD_RETRY_TEXT = "ลองใหม่";

export const dailyExpenseDayPath = (businessDate: string) =>
  `${DAILY_EXPENSE_PATH}/${encodeURIComponent(businessDate)}`;

export const dailyExpenseMonthPath = (month: string) =>
  `${DAILY_EXPENSE_PATH}?${MONTH_PARAM}=${encodeURIComponent(month)}`;
